import Client from "./components/Client";
import GetInTouch from "./components/GetInTouch";
import Hero from "./components/Hero";
import Landing from "./components/Landing";
import SectionComponents from "./components/SectionComponents";
import Why from "./components/Why";

const index = () => {
  return (
    <>
      <Hero />
      <Landing />
      <Why />
      <SectionComponents />
      <Client />
      <GetInTouch />
    </>
  );
};

export default index;
